import { ThemesAction, ThemesActionKeys } from '../actions/themes';
import { UiAction, UiActionKeys } from '../actions/ui';

export interface ThemeData {
	id: string;
	name: string;
	colors: string[]; // rgba()
}

export interface ThemesState {
	[k: string]: ThemeData;
}

const themesInitialState: ThemesState | null = null;

export const themes = (state: ThemesState | null = themesInitialState, action: ThemesAction | UiAction): ThemesState | null => {
	switch (action.type) {
		case ThemesActionKeys.SET_THEMES:
			return action.themes;
		case ThemesActionKeys.DUPLICATE_THEME:
			return {
				...state,
				[action.theme.id]: action.theme,
			};
		case ThemesActionKeys.REMOVE_THEME: {
			const newState = { ...state };
			delete newState[action.id];
			return newState;
		}
		case ThemesActionKeys.RENAME_THEME:
			return {
				...state,
				[action.id]: {
					...(state as ThemesState)[action.id],
					name: action.name,
				},
			};
		case ThemesActionKeys.CHANGE_THEME_COLOR:
			return {
				...state,
				[action.themeId]: {
					...(state as ThemesState)[action.themeId],
					colors: (state as ThemesState)[action.themeId].colors.map((color, index) => (
						index === action.colorIndex ? action.colorValue : color
					)),
				},
			};
		case UiActionKeys.RESET:
			return themesInitialState;
		default:
			return state;
	}
};

export const selectedThemeId = (state: string | null = null, action: ThemesAction | UiAction): string | null => {
	switch (action.type) {
		case ThemesActionKeys.SELECT_THEME:
		case ThemesActionKeys.DUPLICATE_THEME:
			return action.id;
		case ThemesActionKeys.REMOVE_THEME:
			return action.newSelectedThemeId;
		case UiActionKeys.RESET:
			return null;
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/reducer/themes.ts